import IUpdateCompleteWorkOrderRequest from "interfaces/Request/IUpdateCompleteWorkOrderRequest";
import { GlobalState } from "little-state-machine";

export const updateCompleteWorkOrderRequest = (
  state: GlobalState,
  completeWorkOrderRequest: IUpdateCompleteWorkOrderRequest
) => ({
  ...state,
  completeWorkOrderRequest
});
